import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import __ from "lodash";
import { cekCookies } from "../../../../actions";
import axios from "axios";
import { CONFIG, CONFIG_UTIL } from "../../../../config";
import Navbar from "../../navbar/Navbar";
import Sidebar from "../../sidebar/Sidebar";
import { Row, Col } from "react-bootstrap";
import LoaderModal from "../../../modal/LoaderModal";
import accountManagement from "../../../../apis/accountManagement";
import utilManagement from "../../../../apis/utilManagement";
import Collapse from "@material-ui/core/Collapse";

import Loader from "../../../Loader";
class ResetPengerjaan extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isFetching: false,
      loading: false,
      username: null,
      idSiswa: null,
      dataDikerjakan: [],
      dataDikerjakanNonAkademik: [],
    };
  }

  async componentDidMount() {
    document.title = "Reset Pengerjaan";
    this.setState({
      isFetching: true,
    });
    await this.props.cekCookies();

    if (!__.isEmpty(this.props.account)) {
    }

    window.$("#sidebar").mCustomScrollbar({
      theme: "minimal",
    });

    window.$("#sidebarCollapse").on("click", function () {
      window.$("#sidebar, #content").toggleClass("active");
      window.$(".collapse.in").toggleClass("in");
      window.$("a[aria-expanded=true]").attr("aria-expanded", "false");
    });

    this.setState({
      isFetching: false,
    });
  }

  inputUsernameOnChange = async (kode) => {
    this.setState({ username: kode.target.value });
  };

  cariSiswa = async () => {
    this.setState({ loading: true });
    var username = this.state.username;

    const dataPengerjaan = await accountManagement.get(CONFIG.CARI_SISWA_BY_USERNAME + username).catch(function (error) {
      console.log("kelas error " + error);
    });

    console.log(dataPengerjaan);
    if (dataPengerjaan.request.readyState === 4 && dataPengerjaan.status === 200) {
      if (dataPengerjaan.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
        this.setState({
          dataDikerjakan: dataPengerjaan.data.data.dataAkademik,
          dataDikerjakanNonAkademik: dataPengerjaan.data.data.dataNonAkademik,
          idSiswa: dataPengerjaan.data.data.detailSiswa.idSiswa,
        });
      }
    }
    this.setState({ loading: false });
  };

  eksekusiReset = async (id, idSiswa, kodeAspek) => {
    this.setState({ isFetching: true });
    console.log(id);

    const eksReset = await accountManagement.get(CONFIG.RESET_STATUS_PENGERJAAN + id + "&idSiswa=" + idSiswa + "&kodeAspek=" + kodeAspek).catch(function (error) {
      console.log("kelas error " + error);
    });

    console.log(eksReset);
    if (eksReset.request.readyState === 4 && eksReset.status === 200) {
      if (eksReset.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
        this.cariSiswa();
      }
    }
    this.setState({ isFetching: false });
  };

  eksekusiResetTimer = async (idProfil, idSubProfil, idSiswa) => {
    this.setState({ isFetching: true });

    const eksReset = await utilManagement.delete(CONFIG_UTIL.UTIL_RESET_TIMER_SISWA + idProfil + "/" + idSubProfil + "/" + idSiswa + "/123").catch(function (error) {
      console.log("kelas error " + error);
    });

    console.log(eksReset);
    if (eksReset.request.readyState === 4 && eksReset.status === 200) {
      if (eksReset.status === 200) {
        this.cariSiswa();
      }
    }
    this.setState({ isFetching: false });
  };

  eksekusiResetPPBlank = async (idSiswa) => {
    this.setState({ isFetching: true });

    await utilManagement.delete(CONFIG_UTIL.UTIL_RESET_PP_BLANK + idSiswa).catch(function (error) {
      console.log("reset pp blank error " + error);
    });

    this.setState({ isFetching: false });
  };

  eksekusiResetProfilSiswa = async (username) => {
    this.setState({ isFetching: true });

    await accountManagement.get(CONFIG.RESET_PROFIL_SISWA + username).catch(function (error) {
      console.log("reset pp blank error " + error);
    });

    this.setState({ isFetching: false });
  };

  render() {
    return (
      <div className="wrapper">
        <LoaderModal isFetching={this.state.isFetching} />
        <Sidebar account={this.props.account} />
        <div id="content" style={{ paddingBottom: "50px" }}>
          <Navbar />
          {this.loading()}
          <Row>
            <Col sm={3}>
              <input className="form-control" placeholder="Username" value={this.state.username} onChange={this.inputUsernameOnChange.bind(this)}></input>
            </Col>
            <Col sm={2}>
              <button className="btn btn-primary" onClick={this.cariSiswa}>
                {" "}
                <li className="fa fa-search"> Goleki !</li>
              </button>
            </Col>
            {this.state.idSiswa ? (
              <Fragment>
                <Col sm={2}>
                  <button className="btn btn-warning" onClick={(e) => this.eksekusiResetPPBlank(this.state.idSiswa)}>
                    {" "}
                    <li className="fa fa-refresh"> R PP Blank</li>
                  </button>
                </Col>
                <Col sm={2}>
                  <button className="btn btn-warning" onClick={(e) => this.eksekusiResetProfilSiswa(this.state.username)}>
                    {" "}
                    <li className="fa fa-refresh"> R Profil</li>
                  </button>
                </Col>
              </Fragment>
            ) : (
              <></>
            )}
          </Row>
          <br></br>

          <Row>
            <div class="accordion" id="accordionExample">
              <div class="card">
                <div class="card-header" id="headingOne">
                  <h2 class="mb-0">
                    <button class="btn btn-link" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                      Pengerjaan Akademik boss..
                    </button>
                  </h2>
                </div>

                <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                  <div class="card-body">
                    <table className="table">
                      <thead>
                        <th width="10px">No</th>
                        <th>Nama</th>
                        <th>Id Sub Header</th>
                        <th>Profil</th>
                        <th>KTGR</th>
                        <th>Mapel</th>
                        <th>Wkt Submit</th>
                        <th>Status</th>
                      </thead>
                      <tbody>
                        {this.state.dataDikerjakan.map((x, i) => (
                          <tr key={i}>
                            <td>{i + 1}.</td>
                            <td>{x.NAMA_SISWA}</td>
                            <td>{x.ID_SUB_HEADER_HASIL_CBT}</td>
                            <td>{x.NAMA_PROFIL}</td>
                            <td>{x.NAMA_KATEGORI_SUB_PROFIL}</td>
                            <td>{x.NAMA_MATA_PELAJARAN}</td>
                            <td>{x.UPDATED_DATE}</td>
                            <td>
                              {x.STATUS_PENGERJAAN === "0" ? (
                                <button className="btn btn-outline-warning" disabled>
                                  <li className="fa fa-window-close-o"> Reset</li>
                                </button>
                              ) : (
                                <button className="btn btn-outline-danger" onClick={(e) => this.eksekusiReset(x.ID_SUB_HEADER_HASIL_CBT, 0)}>
                                  <li className="fa fa-refresh"> Reset</li>
                                </button>
                              )}
                              &nbsp;
                              <button className="btn btn-outline-primary" onClick={(e) => this.eksekusiResetTimer(x.ID_PROFIL_CBT, x.ID_SUB_PROFIL_CBT, x.ID_SISWA)}>
                                <li className="fa fa-clock-o"> Timer</li>
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header" id="headingTwo">
                  <h2 class="mb-0">
                    <button class="btn btn-link collapsed" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                      Pengerjaan Non Akademik.. !!! Langsung Hapus Pengerjaan hloo !!!!
                    </button>
                  </h2>
                </div>
                <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
                  <div class="card-body">
                    <table className="table">
                      <thead>
                        <th width="10px">No</th>
                        <th>Profil</th>
                        <th>Test</th>
                        <th>Wkt Masuk Profil</th>
                        <th>T.A</th>
                        <th>Status</th>
                      </thead>
                      <tbody>
                        {this.state.dataDikerjakanNonAkademik.map((x, i) => (
                          <tr key={i}>
                            <td>{i + 1}.</td>
                            <td>{x.NAMA_PROFIL}</td>
                            <td>{x.NAMA_PROFIL_AGCU}</td>
                            <td>{x.CREATED_DATE}</td>
                            <td>{x.KODE_TAHUN_AJARAN}</td>
                            <td>
                              <button className="btn btn-outline-danger" onClick={(e) => this.eksekusiReset(x.ID_HEADER_HASIL_CBT, x.ID_SISWA, x.KODE_ASPEK_NON_AKADEMIS)}>
                                <li className="fa fa-refresh"> Reset</li>
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </Row>
          {/* <Row>
                        <Col>
                            <table className="table">
                                <thead>
                                    <th width='10px'>No</th>
                                    <th>Nama</th>
                                    <th>Id Sub Header</th>
                                    <th>Profil</th>
                                    <th>KTGR</th>
                                    <th>Mapel</th>
                                    <th>Wkt Submit</th>
                                    <th>Status</th>
                                </thead>
                                <tbody>
                                    {this.state.dataDikerjakan.map((x, i) => 
                                        <tr key={i}>
                                            <td>{i+1}.</td>
                                            <td>{x.NAMA_SISWA}</td>
                                            <td>{x.ID_SUB_HEADER_HASIL_CBT}</td>
                                            <td>{x.NAMA_PROFIL}</td>
                                            <td>{x.NAMA_KATEGORI_SUB_PROFIL}</td>
                                            <td>{x.NAMA_MATA_PELAJARAN}</td>
                                            <td>{x.UPDATED_DATE}</td>
                                            <td>
                                                {x.STATUS_PENGERJAAN==="0" ?
                                                    <button className="btn btn-outline-warning" disabled> 
                                                        <li className="fa fa-window-close-o"> Reset</li>
                                                    </button>
                                                :
                                                    <button className="btn btn-outline-danger" onClick={(e) => this.eksekusiReset(x.ID_SUB_HEADER_HASIL_CBT)}> 
                                                        <li className="fa fa-refresh"> Reset</li>
                                                    </button>
                                                }
                                                &nbsp;
                                                <button className="btn btn-outline-primary" onClick={(e) => this.eksekusiResetTimer(x.ID_PROFIL_CBT, x.ID_SUB_PROFIL_CBT, x.ID_SISWA)}> 
                                                    <li className="fa fa-clock-o"> Timer</li>
                                                </button>
                                                    
                                            </td>
                                        </tr>
                                    )}                            
                                </tbody>
                            </table>
                            </Col>
                        {this.loading()}    
                    </Row> */}
        </div>
      </div>
    );
  }

  loading = () => {
    if (this.state.loading) {
      return <Loader />;
    }
  };
}
const mapStateToProps = (state) => {
  return {
    account: state.account,
  };
};

export default connect(mapStateToProps, { cekCookies })(ResetPengerjaan);
